import { render, staticRenderFns } from "./PaymentPlanBtn.vue?vue&type=template&id=138ad747&"
import script from "./PaymentPlanBtn.vue?vue&type=script&lang=js&"
export * from "./PaymentPlanBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports